import domReady from './inc/dom-ready.js';
import { boilerplateNavMain } from './inc/nav-main.js';
import elmntIO from './inc/elmnt-io.js';
import { splitWordAnim } from './inc/text-animation.js';
import { bgDots } from './inc/bg-dots.js';
import { accordions } from './inc/accordions.js';
import { mediaContentSlider } from './inc/slider.js';
import { videoGallery } from './inc/video-gallery.js';


domReady( function () {
    boilerplateNavMain();

    const $elmntIos = document.querySelectorAll('[data-io]:not(.ignore-io)');
    $elmntIos.forEach($el => elmntIO($el));

    splitWordAnim();
    bgDots();
    accordions();
    mediaContentSlider();
    videoGallery();
} );